module.exports = __webpack_public_path__ + "static/2-f98e4a8dd6d090c6de9859e604d587e1.png";